import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { Tooltip } from 'react-tooltip';
import EmailSequenceService from "../Services/EmailSequenceService";
import moment from "moment";
import UtilsService from "../Services/UtilsService";
import SequenceEmailOffCanvas from "../Offcanvas/SequenceEmailOffcanvas";
import ReactDOMServer from 'react-dom/server';
import SequenceService from "../Services/SequenceService";
import ModalService from "../Services/ModalService";
import LeadsService from "../Services/LeadsService";
import AddLeadsModal from "../Modals/AddLeadsModal";
import Dropdown from 'react-bootstrap/Dropdown';
import PubSub from 'pubsub-js';

function SequenceEmails() {

    const { id: sequence_id } = useParams();

    const [emailSequences, setEmailSequences] = useState([]);
    const [filteredEmailSequences, setFilteredEmailSequences] = useState([]);
    const [statusFilter, setStatusFilter] = useState('all');
    const [summary, setSummary] = useState({});
    const [show, setShow] = useState(false);
    const [search, setSearch] = useState('');
    const [selectedEmailSequence, setSelectedEmailSequence] = useState(null);
    const onClose = () => setShow(false);

    const [settings, setSettings] = useState({});
    const [executingStep, setExecutingStep] = useState(false);
    const timezone = settings.timezone;
    const [lastAction, setLastAction] = useState({ index: 0, checked: false });
    const [shiftKeyPressed, setShiftKeyPressed] = useState(false);

    function handleKeyPressed() {
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Shift') {
                setShiftKeyPressed(true);
            }
        });

        document.addEventListener('keyup', (e) => {
            if (e.key === 'Shift') {
                setShiftKeyPressed(false);
            }
        });
    }

    function openAddLeadsModal() {
        ModalService.openAddLeadsModal();
    }

    function onLeadsAdded() {
        getEmailSequences();
        getEmailSequenceSummary();
    }

    useEffect(() => {
        getEmailSequences();
        getEmailSequenceSummary();
        getSequenceSettings();
        handleKeyPressed();

        return () => {
            document.removeEventListener('keydown', () => { });
            document.removeEventListener('keyup', () => { });
        };
    }, []);

    useEffect(() => {
        filterEmailSequences();
    }, [search, statusFilter, emailSequences]);

    async function getSequenceSettings() {
        let data = await SequenceService.getSequenceSettings(sequence_id);
        setSettings(data);
    }

    function filterEmailSequences() {
        let sequences = emailSequences;

        if (statusFilter === 'pending') {
            sequences = sequences.filter(es => es.current_step === 1);
        } else if (statusFilter === 'sent') {
            sequences = sequences.filter(es => es.current_step > 1);
        } else if (statusFilter === 'sentStep2') {
            sequences = sequences.filter(es => es.current_step > 2);
        } else if (statusFilter === 'bounced') {
            sequences = sequences.filter(es =>
                es.steps.some(step => String(step.error).toLowerCase().includes('bounced'))
            );
        } else if (statusFilter === 'replied') {
            sequences = sequences.filter(es =>
                es.steps.some(step => String(step.error).toLowerCase().includes('replied'))
            );
        } else if (statusFilter === 'error') {
            sequences = sequences.filter(es =>
                es.steps.some(step => String(step.error).toLowerCase().includes('error'))
            );
        }

        if (search) {
            sequences = sequences.filter(emailSequence => {
                return emailSequence.lead.email.toLowerCase().includes(search.toLowerCase()) ||
                    emailSequence.lead.name.toLowerCase().includes(search.toLowerCase());
            });
        }




        setFilteredEmailSequences(sequences);

    }

    async function getEmailSequences() {
        let { data } = await EmailSequenceService.getEmailSequencesBySequenceId(sequence_id);
        setEmailSequences(data);
    }

    async function getEmailSequenceSummary() {
        let summary = await EmailSequenceService.getEmailSequenceSummaryBySequenceId(sequence_id);
        setSummary(summary);

    }

    function showSequenceEmailsDetails(emailSequence) {
        setSelectedEmailSequence(emailSequence);
        setShow(true);
    }

    function renderTooltipContent(sent_at) {
        return ReactDOMServer.renderToStaticMarkup(
            <div>
                <h5>Details:</h5>

                <div>Local time: </div>
                <div>Account time: </div>
            </div>
        )
    }

    async function onRemoveLead(emailSequence) {
        let confirmMessage = 'Are you sure you want to remove this lead from the sequence?';
        if (window.confirm(confirmMessage)) {
            let leads_id = [emailSequence.lead._id];
            let { message } = await EmailSequenceService.removeLeadsFromSequence({ sequence_id, leads_id });
            PubSub.publish('show-basic-notification', {
                title: 'Lead removed',
                message: message
            });
            if (window.confirm('Do you also want to delete this lead from the system?')) {
                await LeadsService.deleteLeads(leads_id);
            }
            getEmailSequences();
            getEmailSequenceSummary();
        }
    }

    function getContactsSelectedCount() {
        return emailSequences.filter((emailSequence) => emailSequence.checked).length;
    }

    function onCheckRow(event, index) {
        let checked = event.target.checked;
        let emailSequence = emailSequences[index];
        emailSequence.checked = checked;

        if (shiftKeyPressed) {
            let lastCheckedIndex = lastAction.index;
            let startIndex = lastCheckedIndex < index ? lastCheckedIndex : index;
            let endIndex = lastCheckedIndex > index ? lastCheckedIndex : index;

            for (let i = startIndex; i <= endIndex; i++) {
                emailSequences[i].checked = checked;
            }
        }

        setLastAction({ index, checked });
        setEmailSequences([...emailSequences]);
    }

    async function onRemoveLeads() {
        let leads_id = emailSequences.filter((emailSequence) => emailSequence.checked).map((emailSequence) => emailSequence.lead._id);
        if (leads_id.length === 0) return;
        if (window.confirm('Are you sure you want to remove these leads from the sequence?')) {
            let { message } = await EmailSequenceService.removeLeadsFromSequence({ sequence_id, leads_id });
            PubSub.publish('show-basic-notification', {
                title: 'Leads removed',
                message: message
            });
            if (window.confirm('Do you also want to delete these leads from the system?')) {
                await LeadsService.deleteLeads(leads_id);
            }
            getEmailSequences();
            getEmailSequenceSummary();
        }
    }

    async function executeEmailStep(step) {
        if (!step) return;
        setExecutingStep(true);
        PubSub.publish('loading.notification', { message: 'Executing step...', show: true });
        let { message } = await EmailSequenceService.executeEmailStep(step._id);
        PubSub.publish('loading.notification.hide');
        setExecutingStep(false);
        PubSub.publish('show-basic-notification', {
            title: 'Step executed',
            message
        });
        getEmailSequences();
        getEmailSequenceSummary();
    }

    function executeStep1(emailSequence) {
        executeEmailStep(emailSequence.steps[0]);
    }

    function executeStep2(emailSequence) {
        executeEmailStep(emailSequence.steps[1]);
    }

    async function checkIfBounced(step) {
        if (!step) return;
        setExecutingStep(true);
        PubSub.publish('loading.notification', { message: 'Checking bounce...', show: true });
        await EmailSequenceService.checkIfEmailStepWasBounced(step._id);
        PubSub.publish('loading.notification.hide');
        setExecutingStep(false);
        PubSub.publish('show-basic-notification', {
            title: 'Bounce check',
            message: 'Verification complete'
        });
        getEmailSequences();
        getEmailSequenceSummary();
    }

    async function checkIfReplied(step) {
        if (!step) return;
        setExecutingStep(true);
        PubSub.publish('loading.notification', { message: 'Checking reply...', show: true });
        await EmailSequenceService.checkIfEmailStepWasReplied(step._id);
        PubSub.publish('loading.notification.hide');
        setExecutingStep(false);
        PubSub.publish('show-basic-notification', {
            title: 'Reply check',
            message: 'Verification complete'
        });
        getEmailSequences();
        getEmailSequenceSummary();
    }

    async function resetEmailSteps(emailSequence) {
        if (!emailSequence || !emailSequence.steps.length) return;
        if (!window.confirm('Are you sure you want to reset this email sequence?')) return;
        setExecutingStep(true);
        PubSub.publish('loading.notification', { message: 'Resetting steps...', show: true });
        for (let step of emailSequence.steps) {
            await EmailSequenceService.resetEmailStep(step._id);
        }
        PubSub.publish('loading.notification.hide');
        setExecutingStep(false);
        PubSub.publish('show-basic-notification', {
            title: 'Steps reset',
            message: 'Sequence steps reset'
        });
        getEmailSequences();
        getEmailSequenceSummary();
    }



    function renderEmailSequences() {

        let dateFormat = 'MM/DD/YYYY hh:mm:ss A';

        let localEmailSequences = (search || statusFilter !== 'all') ? filteredEmailSequences : emailSequences;

        return localEmailSequences.map((emailSequence, i) => {

            let stepIndex = emailSequence.current_step - 1;
            let step = emailSequence.steps[stepIndex];

            if (!step) {
                step = emailSequence.steps[emailSequence.steps.length - 1];
            }

            let buttonsHTML = emailSequence.steps.map((step, i) => {

                let className = 'btn btn-outline-primary btn-sm btn-circle mx-1';
                let tooltipContent = `Email not sent yet, estimated to be sent on ${moment(step.estimated_send_at).format(dateFormat)}`;

                if (step.email_log && step.status === 'sent' && step.email_log.sent_result === 'email sent') {
                    className = 'btn btn-outline-success btn-sm btn-circle mx-1';
                    tooltipContent = `Email successfully sent at ${moment(step.email_log.sent_at).format(dateFormat)}`;
                } else if (step.email_log && step.email_log.sent_result !== 'email sent') {
                    className = 'btn btn-outline-danger btn-sm btn-circle mx-1';
                    tooltipContent = `Email failed with error ${step.email_log.sent_result} at ${moment(step.email_log.sent_at).format(dateFormat)}`;
                } else if (step.status === 'replied') {
                    className = 'btn btn-outline-info btn-sm btn-circle mx-1';
                    tooltipContent = `Email replied at ${moment(step.replied_at).format(dateFormat)}`;
                } else if (step.status === 'bounced') {
                    className = 'btn btn-outline-info btn-sm btn-circle mx-1';
                    tooltipContent = `Email not sent, reason: bounced at ${moment(step.bounced_at).format(dateFormat)}`;
                } else if (step.status === 'error') {
                    className = 'btn btn-outline-danger btn-sm btn-circle mx-1';
                    tooltipContent = `Email not sent, reason: ${step.error} at ${moment(step.error_at).format(dateFormat)}`;
                } else {
                    className = 'btn btn-outline-warning btn-sm btn-circle mx-1';
                }

                return <button
                    data-tooltip-id="sequence-emails-tooltip"
                    data-tooltip-content={tooltipContent}
                    className={className}>S{i + 1}</button>
            });

            return (
                <div key={`email-sequence-${i}`} className='email-sequence-item'>
                    <div className="form-check">
                        <input className="form-check-input"
                            onChange={(e) => onCheckRow(e, i)}
                            checked={emailSequence.checked}
                            type="checkbox" value="" id={'sequence-email-' + i} />
                    </div>

                    <span
                        onClick={() => showSequenceEmailsDetails(emailSequence)}
                        className="fs-13"
                        style={{ minWidth: '160px', maxWidth: '160px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        To  <span className='text-primary bold' >
                            {emailSequence.lead.name}
                        </span>
                        <div className='text-muted small'> {emailSequence.lead.email}</div>
                        <div className='text-muted small mt-1'>
                            <i>
                                {moment(emailSequence.created_at).format('ll LTS')}
                            </i>
                        </div>
                    </span>

                    <div className="fs-12"
                        style={{ flex: 1, marginLeft: '10px' }}
                        onClick={() => showSequenceEmailsDetails(emailSequence)}>
                        <div className="bold mb-1">
                            {UtilsService.replaceTextWithUserAndLeadVariables(step?.sequence_step?.subject || '', emailSequence.user, emailSequence.lead)}
                        </div>
                        <div>{UtilsService.replaceTextWithUserAndLeadVariables(step.sequence_step?.variations[0]?.textBody?.substring(0, 300) || '', emailSequence.user, emailSequence.lead)}...</div>
                    </div>

                    <div className="d-flex">
                        {buttonsHTML}
                        <Dropdown className="ms-2">
                            <Dropdown.Toggle variant="muted"
                                className="no-chevron btn-sm" id={`dropdown-basic-${i}`}>
                                <i className="fas fa-ellipsis-h"></i>
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item
                                    disabled={executingStep || !(emailSequence.steps[0] && emailSequence.steps[0].status === 'pending')}
                                    onClick={() => executeStep1(emailSequence)}>
                                    Execute step 1
                                </Dropdown.Item>
                                <Dropdown.Item
                                    disabled={executingStep || !(emailSequence.steps[1] && emailSequence.steps[1].status === 'pending')}
                                    onClick={() => executeStep2(emailSequence)}>
                                    Execute step 2
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => checkIfBounced(emailSequence.steps[0])}>
                                    Check if email bounced
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => checkIfReplied(step)}>
                                    Check if email was replied
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => resetEmailSteps(emailSequence)}>
                                    Reset steps
                                </Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item onClick={() => onRemoveLead(emailSequence)}>Delete</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>

                </div>
            )
        })
    }

    return (
        <div>

            <SequenceEmailOffCanvas
                show={show}
                onClose={onClose}
                selectedEmailSequence={selectedEmailSequence}
            />
            <AddLeadsModal sequence_id={sequence_id} onLeadsAdded={onLeadsAdded} />

            <div className="container">
                <div className="sequence-detail-container">
                    {executingStep && (
                        <div className="small my-2 text-muted">
                            <i className="fas fa-spinner fa-spin me-2"></i>
                            executing step...
                        </div>
                    )}

                    <div className='d-flex align-items-center mb-2'>
                        <div className='small me-3 bold'>
                            {getContactsSelectedCount()} Contacts selected
                        </div>

                        <button
                            onClick={onRemoveLeads}
                            style={{ marginLeft: 'auto' }}
                            disabled={getContactsSelectedCount() === 0}
                            className='btn btn-outline-danger btn-sm '>
                            <i className="fas fa-trash me-2"></i>
                            Remove leads
                        </button>
                    </div>

                    <div className='email-sequence-contacts-stats'>
                        <input type="text"
                            value={search}
                            className="input-search"
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="search by email" />
                        <button
                            onClick={openAddLeadsModal}
                            style={{ width: '150px' }}
                            className="btn btn-primary btn-sm ms-2">
                            <i className="fas fa-plus me-2"></i>
                            Add leads
                        </button>
                    </div>

                    <div className='email-sequence-contacts-stats'>
                        <div
                            className={`sequence-contacts-stats-item ${statusFilter === 'all' ? 'active' : ''}`}
                            onClick={() => setStatusFilter('all')}
                        >
                            <div className='bold'>{summary.total}</div>
                            <div> Total</div>
                        </div>

                        <div
                            className={`sequence-contacts-stats-item ${statusFilter === 'pending' ? 'active' : ''}`}
                            onClick={() => setStatusFilter('pending')}
                        >
                            <div className='bold'>{summary.pending}</div>
                            <div>Pending</div>
                        </div>

                        <div
                            className={`sequence-contacts-stats-item ${statusFilter === 'sent' ? 'active' : ''}`}
                            onClick={() => setStatusFilter('sent')}
                        >
                            <div className='bold'>{summary.sent}</div>
                            <div>Sent 1st email</div>
                        </div>
                        <div
                            className={`sequence-contacts-stats-item ${statusFilter === 'sentStep2' ? 'active' : ''}`}
                            onClick={() => setStatusFilter('sentStep2')}
                        >
                            <div className='bold'>{summary.sentStep2}</div>
                            <div>Sent 2nd email</div>
                        </div>

                        <div
                            className={`sequence-contacts-stats-item ${statusFilter === 'bounced' ? 'active' : ''}`}
                            onClick={() => setStatusFilter('bounced')}
                        >
                            <div className='bold'>{summary.bounced || 0}</div>
                            <div>Bounced</div>
                        </div>

                        <div
                            className={`sequence-contacts-stats-item ${statusFilter === 'replied' ? 'active' : ''}`}
                            onClick={() => setStatusFilter('replied')}
                        >
                            <div className='bold'>{summary.replied || 0}</div>
                            <div>Replied</div>
                        </div>

                        <div
                            className={`sequence-contacts-stats-item ${statusFilter === 'error' ? 'active' : ''}`}
                            onClick={() => setStatusFilter('error')}
                        >
                            <div className='bold'>{summary.error || 0}</div>
                            <div>Error</div>
                        </div>



                    </div>

                    {renderEmailSequences()}


                </div>
            </div>
            <Tooltip id="sequence-emails-tooltip" />
        </div>
    )

}

export default SequenceEmails;
